import axios from 'axios';
import { useState, useEffect } from 'react';
import { apiConstant } from '../constant';
import useConfirm from '../../../../components/common/useConfirm';

const useGetData = (id: string | undefined) => {
  const [moduleData, setModuleData] = useState<any>({ list: [] });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSync, setIsSync] = useState(false);
  const [tniTopic, setTniTopic] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [facultyData, setFacultyData] = useState([]);
  const [Sync, confirmSync] = useConfirm(
    'Row',
    'Are you sure you want to add row?',
  );

  const [DialogDeleteRow, confirmDeleteRow] = useConfirm(
    'DELETE',
    'Are you sure you want to delete Row?',
  );
  const addRow = async () => {
    const ans = await confirmSync();
    if (!ans) return;
    let values = { ...moduleData };
    values.list.push({
      april: {},
      may: {},
      june: {},
      july: {},
      august: {},
      september: {},
      october: {},
      november: {},
      december: {},
      january: {},
      february: {},
      march: {},
    });
    setModuleData(values);
  };
  useEffect(() => {
    setIsLoading(true);
    if (id) {
      axios
        .get(`/api/${apiConstant.getPlanByid}/${id}`)
        .then((res) => {
          setModuleData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    }
  }, [isSync]);

  useEffect(() => {
    axios
      .get(`/api/${apiConstant.categoryTopic}/${moduleData.category_id}`)
      .then((res) => {
        if (res.data) {
          setTniTopic(res.data.topics);
        }
      })
      .catch((err) => {
        setError(err);
      });
  }, [moduleData]);

  const handleDeleteRows = async (rowIdx: number) => {
    const ans = await confirmDeleteRow();
    if (!ans) return;
    let data = { ...moduleData };
    data.list.splice(rowIdx, 1);
    setModuleData(data);
  };

  useEffect(() => {
    axios
      .get('/api/masterlistofFaculty/facultyList/facultyForAutoComplete')
      .then((res) => {
        setFacultyData(res.data);
      })
      .catch((err) => console.log(err));
    axios
      .get('/api/customerRoutes/customerList/customerForAutoComplete')
      .then((res) => {
        setCustomerData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  return {
    DialogDeleteRow,
    handleDeleteRows,
    moduleData,
    tniTopic,
    isLoading,
    error,
    addRow,
    Sync,
    customerData,
    facultyData,
  };
};

export default useGetData;
